<template>
	<div>
		<b-button :variant="btn_variant" :size="size" @click.stop="printStart">
            <slot>
            </slot>
        </b-button>
        
        <template v-if="print_started">
            <div :key="start_key" style="margin-left: -9999px; margin-top:-9999px; width: 1100px; position:absolute;">
                <div id="printout">
                <div :class="is_printing? 'printing px-5' : 'not_printing'">
                    <div class="d-flex align-items-center justify-content-between" style="height:80px;">      
                        <b-img :src="titleImg" style="width: 110px;"></b-img>          
                        <div class="gray-600 f-90"> 공급망 ESG 실사 / {{ answer_company.company_name }}</div>
                    </div>
                    <h2 class="fw-600 mb-5 py-5 px-5 teal8 bg-tealgray200"> {{ answer_company.campaign_name }} 질문지</h2>
                    <hr class="border-0 py-3">

                    <template v-if="is_qe_evaluate_loaded && print_target_questions.length">
                        <div v-for="(question_code_item, index) in print_target_questions" :key="question_code_item.id">
                            <template v-if="print_mode == 'only_question'">
                                <questions-for-print
                                    class="text-left"
                                    :question_code="question_code_item"
                                    :is_final_question_code="index === print_target_questions.length - 1"
                                    @load-finished="handleLoadFinished"
                                    >
                                </questions-for-print>
                            </template>
                            <template v-else-if="print_mode == 'question_and_audit'" >
                                <AnswersForPrintV2
                                    class="text-left"
                                    :question_code="question_code_item"
                                    :is_final_question_code="index === print_target_questions.length - 1"
                                    @load-finished="handleLoadFinished"
                                    >
                                </AnswersForPrintV2>
                            </template>
                        </div>
                    </template>
                    
<!--                    <div class="px-8 py-5 bgray-300" >    -->
<!--                        <div class="f-85 mb-3" :class="$i18n.locale=='en'?'':'pt-3'">-->
<!--                                <div class="fw-300 mb-2">{{$t(`copyright 2025. ㈜퀀티파이드이에스지, all rights reserved.`)}} </div>-->
<!--                                <div class="fw-300 mb-2">-->
<!--                                    {{$t(`본 문서에 게재된 평가 질문 문항 정보, 질문지 레이아웃을 포함한 모든 정보는 저작권법에 의하여 보호받는 저작물로 그 저작권은 ㈜퀀티파이드이에스지에 있습니다. 따라서 본 보고서에 대한 무단 복제, 전체, 배포를 원칙적으로 금지합니다. 또한 본 문서를 통해 수익을 얻거나 이에 상응하는 혜택을 누리고자 하는 경우 ㈜퀀티파이드이에스지와 사전에 별도 서면 협의를 거쳐야 하며, 협의가 완료된 후에도 해당 보고서의 내용을 게재하는 경우 출처가 ㈜퀀티파이드이에스지임을 밝혀야 합니다.`)}}-->
<!--                                </div>-->
<!--                                <div class="fw-300 ">-->
<!--                                    <template v-if="$i18n.locale=='ko'">본 문서에 게재된 정보 또는 위와 관련한 사항에 대한 보다 자세한 정보는 <a href="http://qesg.co.kr/" target="_blank">qesg.co.kr</a>에 문의해 주십시오.</template>-->
<!--                                    <template v-else>Please contact <a href="http://qesg.co.kr/" target="_blank">qesg.co.kr</a> for more detailed information on the information presented in this report or related to the above. </template>-->
<!--                                </div>-->
<!--                        </div>-->
<!--                        <div class="text-right">-->
<!--                            <b-img src="/images/QuantifiedESG_Logo_v3_Basic.svg" style="width: 110px;"></b-img>          -->
<!--                        </div>-->
<!--                    </div>-->
                </div>

                </div> <!-- print_out div-->
            </div>
        </template>
        

		<b-modal id="pdf_down_modal" size="lg" hide-footer @show="is_printing=true" @hide="is_printing=false">
            <template v-slot:modal-title>
                <span>출력하기</span>
            </template>
            <div v-if="print_mode == 'not_determined'">
                <template v-if="check_access_lv">
                    <div class="mt-2 mb-4 text-center fw-500">출력물에 상세평가(Audit) 내용을 포함하시겠습니까?</div>
                    <div class="text-center mb-3">
                        <b-btn class="mr-3" variant="dark-border"
                            @click="print_mode = 'question_and_audit'"
                            >
                            예, 포함합니다.
                        </b-btn>
                        <b-btn variant="dark-border" @click="print_mode = 'only_question'">
                            아니오, 질문과 답변만 필요합니다.
                        </b-btn>
                    </div>   
                </template>
                <template v-else>
                    <b-button variant="blue" @click="print_mode = 'only_question'">
                        {{ answer_company.company_name }}
                        답변지 출력하기
                    </b-button>
                </template>
            </div>
            <div v-else>
                <div class="d-block text-center">
                    <div class="pb-3">
                        <b-progress :value="progress_rate" :max="100" show-progress animated /> 
                    </div>

                    <div v-if="print_ready!=true">
                        <div class="d-flex align-items-center justify-content-center"> <b-spinner small class="mr-2" type="grow"></b-spinner>  {{ msg }}</div>
                    </div>
                    <div v-else class="mt-3">
                        <p class="text-left fw-500"> {{$t(`PDF로 다운로드 하실 경우 아래 설명을 확인 후 진행해 주세요.`)}}</p>

                        <b-tabs content-class="bg-white pt-3 pb-4 mb-4">
                            <b-tab :title="$t(`크롬(Google Chrome) 사용중인 경우`)" active>
                                <b-img :src="$i18n.locale=='en'?'/images/how_to_print_chrome_en.png':'/images/how_to_print_chrome.png'" fluid style="max-width: 90%"></b-img>
                            </b-tab>
                            <b-tab :title="$t(`엣지(Microsoft Edge) 사용중인 경우`)">
                                <b-img :src="$i18n.locale=='en'?'/images/how_to_print_edge_en.png':'/images/how_to_print_edge.png'" fluid style="max-width: 90%"></b-img>
                            </b-tab>
                        </b-tabs>
                        <b-button v-if="isIE!=true" v-print="'#printout'" variant="blue">PDF 인쇄 / 다운로드</b-button>
                        <b-button v-else variant="blue" @click="pdf.save('company_report.pdf')">PDF 다운로드</b-button>
                    </div>
                </div>                
            </div>
            <b-button class="float-right" variant="dark" @click="cancel()">취소</b-button>
		</b-modal>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import QuestionsForPrint from '@shared_components/client/components/QuestionsForPrint';
import * as th from 'tree-helper';
import AnswersForPrintV2 from '@/components/print/AnswersForPrint_v2.vue';
import titleImg from '@shared/assets/img/common/QuantifiedESG_Logo_v3_Basic.png'
;
export default {
    name: 'AuditPrintButtonV2',
    props: {
        btn_variant: {
            type: String,
            default: 'dark-border'
        },
        size: {
            type: String,
            default: ''
        }
    },
    components: {
        AnswersForPrintV2,
        QuestionsForPrint,
    },
    data () {
        return {
            print_target_questions: [],
            start_key: Math.random()*1000,
            propTitle: 'mypdf',
            print_started: false,
            print_ready: false,
            pdf: '',
            // print_target_questions_started: [],
            print_target_questions_loaded: [],
            msg: this.$t('PDF 파일 준비중... 최대 1분 정도 소요될 수 있습니다.'),
            is_printing: false,
            print_mode: 'not_determined',
            titleImg,
        };
    },
    computed:{
        ...mapState(['template_tree', 'campaign', 'is_admin','company_id']),
        ...mapState('questions',['answer_company']),
        ...mapState('score', ['is_evaluate_loaded']),
        ...mapState('industry_scores', ['is_qe_evaluate_loaded']),
        target_template_contents(){
            if (this.view_mode=='provider') {
                return this.template_in_progress.template_contents;
            } else {
                return this.template_tree.template_contents;
            }
        },   
        num_of_print_target_questions () {
            // return this.print_target_questions.length * 2
            return this.print_target_questions.length;
        },
        // num_of_print_target_questions_started(){
        // 	return this.print_target_questions_started.length
        // },
        num_of_print_target_questions_loaded () {
            return this.print_target_questions_loaded.length;
        },
        progress_rate () {
            // return ((this.num_of_print_target_questions_loaded + this.num_of_print_target_questions_started) / this.num_of_print_target_questions) * 100
            return (this.num_of_print_target_questions_loaded / this.num_of_print_target_questions) * 100;
        },
        check_access_lv(){
            return this.is_admin == 4 || [405, 2948].includes(this.company_id);
        }	
    },
    watch:{
        async progress_rate (new_value) {
            if (new_value >= 100) {
                if(this.isIE) this.pdf = await this.makePDF('#printout');
                this.print_ready = true;
                this.msg = '출력 준비가 완료되었습니다.';
            }
        },
        is_printing (_printing_status) {
            if (!_printing_status) {
                this.initializePrintButton();
            }
        }
    },
    async created () {
        this.initializePrintButton();

        if(this.is_evaluate_loaded==false){
            await this.$store.dispatch('score/readAllEvaluateResult', {
                campaign_id: this.answer_company.campaign_id,
                company_name: this.answer_company.company_name,
                project_code: this.answer_company.project_code
            });
        }
    },
    beforeDestroy () {
        this.initializePrintButton();
    },
    methods: {
        ...mapActions('industry_scores', ['readQeEvaluateResult']),
        async printStart () {
            this.$bvModal.show('pdf_down_modal');
            if (!this.print_started) {
                await this.initiatePrintTargetQuestions();
                this.print_target_questions_loaded = [];
                this.print_started = true;
            }
        },
        async initiatePrintTargetQuestions () {
            this.print_target_questions = [];
            await Promise.all([
                this.readQeEvaluateResult({
                    campaign_id: this.answer_company.campaign_id,
                    company_id: this.answer_company.company_id,
                    project_code: this.answer_company.project_code
                })
                    .catch(e=>{
                        console.error(e);
                    }),
                this.$store.dispatch('score/readOverallComment', {
                    campaign_id: this.answer_company.campaign_id, 
                    company_id: this.answer_company.company_id, 
                    question_code: this.question_code
                }),
                this.$store.dispatch('makeTemplateTreeByCompanyId', {
                    campaign_id: this.answer_company.campaign_id,
                    company_id: this.answer_company.company_id
                })
            ]);
            
            let template_contents = this.target_template_contents;
            let temp_print_target = [];
            th.breadthFirstSearch(template_contents, node => {
                if(typeof node.children == 'undefined' || node.children.length == 0){
                    temp_print_target.push(node.question_code);
                }
            });
            
            this.print_target_questions = temp_print_target;
        },
        async makePDF (sel) {
            window.html2canvas = html2canvas; //Vue.js 특성상 window 객체에 직접 할당해야한다.
            let pdf = new jsPDF('p', 'mm', 'a4');

            let canvas = pdf.canvas;
            const pageWidth = 210; //캔버스 너비 mm
            const pageHeight = 295; //캔버스 높이 mm
            canvas.width = pageWidth;

            let ele = document.querySelector(sel);
            let width = ele.offsetWidth; // 셀렉트한 요소의 px 너비
            let height = ele.offsetHeight; // 셀렉트한 요소의 px 높이
            let imgHeight = pageWidth * height/width; // 이미지 높이값 px to mm 변환

            if (!ele) {
                console.warn(sel + ' is not exist.');
                return false;
            }
            const _converted = await html2canvas(ele);
            let position = 0;
            const imgData = _converted.toDataURL('image/png');
            pdf.addImage(imgData, 'png', 0, position, pageWidth, imgHeight, undefined, 'slow');

            // Paging 처리
            let heightLeft = imgHeight; // 페이징 처리를 위해 남은 페이지 높이 세팅.
            heightLeft -= pageHeight;
            while (heightLeft >= 0) {
                position = heightLeft - imgHeight;
                pdf.addPage();
                pdf.addImage(imgData, 'png', 0, position, pageWidth, imgHeight);
                heightLeft -= pageHeight;
            }
            
            return pdf;	
        },
        cancel () {
            this.initializePrintButton();
            this.$bvModal.hide('pdf_down_modal');
        },
        initializePrintButton () {
            this.print_started = false;
            this.print_ready = false;
            this.is_printing = false;
            this.print_target_questions = [];
            this.print_target_questions_loaded = [];
            this.print_mode = 'not_determined';
            this.msg = this.$t('PDF 파일 준비중... 최대 1분 정도 소요될 수 있습니다.');
        },
        handleLoadFinished (question_code){
            this.print_target_questions_loaded.push(question_code);
            
            if (question_code === this.print_target_questions[this.print_target_questions.length - 1]) {
                while (this.progress_rate < 1) {
                    this.print_target_questions_loaded.push('dummy');
                }
            }
        }
    }
};
</script>
<style scoped>
.printing{
	display: block;
}

.not_printing{
	display: none;
}
</style>
